import EventListener from '@/services/EventListener/EventListener.ts';
import { GlobalEventsMap } from './IGlobalEvents.ts';

class GlobalEvents extends EventListener<GlobalEventsMap> {
}

const globalEvents = new GlobalEvents()
export default globalEvents
